// extracted by mini-css-extract-plugin
export default {"inputWrapper":"DailyPayPage-module__inputWrapper__NcjNW"};